/*
 * @Author: your name
 * @Date: 2021-04-16 14:21:14
 * @LastEditTime: 2021-04-16 14:23:31
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\financial.js
 */
export default [{
    path: '/management',
    component: resolve => require(['../../views/management/index.vue'], resolve),
    meta: {
      title: '财务管理'
    }
  },
  {
    path: '/payment',
    component: resolve => require(['../../views/management/payment/payment'], resolve),
    meta: {
      title: '付款审核'
    }
  },
  {
    path: '/reconciliation',
    component: resolve => require(['../../views/management/reconciliation/reconciliation'], resolve),
    meta: {
      title: '收账对账'
    }
  },
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/financial.js